<form (submit)="handleOnSubmit($event)" [formGroup]="form">
  <h2 mat-dialog-title>{{ 'GET_CHARGING_PROFILE' | translate }}</h2>

  <mat-dialog-content>
    <div class="input-row">
      <mat-form-field floatLabel="auto">
        <mat-label>{{ 'EVSE ID' | translate }}</mat-label>
        <input matInput formControlName="evseID" type="number" />
      </mat-form-field>
    </div>
    <div class="input-row">
      <mat-form-field>
        <mat-label>{{ 'CHARGING_PROFILE_PURPOSE' | translate }}</mat-label>
        <mat-select formControlName="chargingProfilePurpose">
          @for (item of purposes; track item) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-row">
      <mat-form-field>
        <mat-label>{{ 'CHARGING_LIMIT_SOURCE' | translate }}</mat-label>
        <mat-select formControlName="chargingLimitSource" multiple="true">
          @for (item of limitSources; track item) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-row">
      <mat-form-field floatLabel="auto">
        <mat-label>{{ 'STACK_LEVEL' | translate }}</mat-label>
        <input matInput formControlName="stackLevel" type="number" />
      </mat-form-field>
    </div>

    <div formArrayName="chargingProfileId">
      @for (item of ids.controls; track item; let i = $index) {
        <div class="mb-4 flex" [formGroupName]="i">
          <mat-form-field floatLabel="auto">
            <mat-label>{{ 'CHARGING_PROFILE_ID' | translate }}</mat-label>
            <input matInput formControlName="ID" type="number" />
          </mat-form-field>
          <button mat-icon-button class="ml-4 mt-4" (click)="deleteInput(i)" type="button">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="mb-4">
      <button mat-button (click)="addInput()" type="button">
        <mat-icon>add</mat-icon>
        {{ 'ADD' | translate }}
      </button>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ 'GET' | translate }}
    </button>
    <button mat-raised-button (click)="close()" type="button">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</form>
